import React from 'react';

const Login = () => {
    return (
        <div>
            Страница логина
        </div>
    );
};

export default Login;